/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { InitialScan, ScanStatus } from './generated';

export class VirusScanner {
  protected axiosInstance: AxiosInstance;

  constructor(protected url: string, protected password: string, axiosInstance: AxiosInstance | undefined = undefined) {
    if (!axiosInstance) {
      this.axiosInstance = axios.create();
    } else {
      this.axiosInstance = axiosInstance;
    }

    this.url = url.replace(/\/+$/, '');
  }

  /**
   * Create a request to scan a file
   * @returns InitialScan Initial scan object
   * @throws ApiError
   */
  public initiateScan(): Promise<InitialScan> {
    return this.handleResponse(
      this.axiosInstance.post<InitialScan>(`${this.url}/scan`, undefined, {
        headers: {
          'x-api-key': this.password,
        },
      }),
    );
  }

  /**
   * Given a scan ID get its current status
   * @returns ScanStatus Returns the status of this scan job.
   * @throws ApiError
   */
  public getScanStatus(id: string): Promise<ScanStatus> {
    return this.handleResponse(
      this.axiosInstance.get<ScanStatus>(`${this.url}/scan/${id}`, {
        headers: {
          'x-api-key': this.password,
        },
      }),
    );
  }

  /**
   * Remove all files associated with this scan
   * @returns any Completed successfully
   * @throws ApiError
   */
  public cleanUp(id: string): Promise<void> {
    return this.handleResponse(
      this.axiosInstance.delete<void>(`${this.url}/scan/${id}`, {
        headers: {
          'x-api-key': this.password,
        },
      }),
    );
  }

  protected async handleResponse<T>(promise: Promise<AxiosResponse<T>>): Promise<T> {
    const result = promise
      .then((response) => response.data)
      .catch((error) => {
        throw this.handleAxiosError(error);
      });
    return result;
  }

  handleAxiosError(error: AxiosError): Error {
    const { response } = error;
    if (!response || (typeof error == 'object' && !error.isAxiosError)) {
      return error;
    }
    throw new Error(`Error received after making request to virus scanner: ${(response.data as any)?.message}`);
  }
}
